import { TrainingItem } from "./training-item";

export class TrainingItemGroup {
   name!: string;
   number!: string | null;
   eqmsScopes!: string[];
   trainingItems!: TrainingItem[];
}
